import React, {useState} from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import MessageIcon from '@material-ui/icons/Message';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const useStyles = makeStyles((theme) => ({
    textForm: {
      textAlign: "left",
      //flexGrow: 1,
      //marginLeft:theme.spacing(1),
      //padding: theme.spacing(2),
      //margin: theme.spacing(2),
    },
    text: {
      textAlign: "center",
      //padding: theme.spacing(2),
      //margin: theme.spacing(2),
    },
    textExplanation: {
      textAlign: "justify",
      //padding: theme.spacing(2),
      //margin: theme.spacing(2),
    },
    select: {
      minWidth: 250,
    },
    table: {
        minWidth: 650,
    }
}));

export default function SleepLogTable (props) {
    const classes = useStyles();
    const {value} = props;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const defaultQualityOptions = ["Very Poor", "Poor", "Decent", "Good", "Very good"];

    function handlePageChange(event, newPage) {
        setPage(newPage);
    }

    function handleRowsPerPageChange(event) {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    if (value){
    return <>
    <TableContainer component={Paper}>
        <Table className={classes.table} size="small" aria-label="sleep-log-data-table">
            <TableHead> 
                <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Sleep Efficiency</TableCell>
                    <TableCell>Bedtime</TableCell>
                    <TableCell>Lights Out</TableCell>
                    <TableCell>Wake Time</TableCell>
                    <TableCell>Time In Bed</TableCell>
                    <TableCell>Time Asleep</TableCell>
                    <TableCell>Sleep Quality</TableCell>
                    <TableCell padding="checkbox"></TableCell>       
                </TableRow>
            </TableHead>
            <TableBody>
                {value.docs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(doc=>
                    <TableRow key={doc.id}>
                        <TableCell component="th" scope="row">{doc.get("bedtime").toDate().toLocaleDateString("en-US")}</TableCell>
                        <TableCell>{doc.get("sleepEfficiency")} %</TableCell>
                        <TableCell>{doc.get("bedtime").toDate().toLocaleTimeString("en-US")}</TableCell>
                        <TableCell>{doc.get("lightsOut").toDate().toLocaleTimeString("en-US")}</TableCell>
                        <TableCell>{doc.get("awake").toDate().toLocaleTimeString("en-US")}</TableCell>
                        <TableCell>{doc.get("totalTimeInBed")} H</TableCell>
                        <TableCell>{doc.get("totalSleepTime")} H</TableCell>
                        <TableCell>{defaultQualityOptions[doc.get("sleepQuality")]} <IconButton onClick={()=> props.onCommentOpen(doc.get("comments"))}><MessageIcon/></IconButton></TableCell>  
                        <TableCell><IconButton onClick={()=>props.onConfirmDeleteOpen(doc.id)}><DeleteForeverIcon/></IconButton></TableCell>
                </TableRow>)}
            </TableBody>
        </Table>
    </TableContainer> 
    <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={value.docs.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
        />
    </>
    }
    return null;
}

